import React from 'react';
import { useAdminContext } from './adminContext';
import { AdminSpeakersModule } from '../../components/admin/AdminSpeakersModule';

export function AdminSpeakersPage() {
  const { adminKey } = useAdminContext();

  return (
    <div className="space-y-6 animate-in fade-in duration-300">
      <AdminSpeakersModule adminKey={adminKey} />
    </div>
  );
}

export default AdminSpeakersPage;
